import React, { createContext, useEffect, useState, useContext } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authData, setAuthData] = useState({
    userData: null,
    token: null,
    role: null,
    isLoggedIn: false,
  });

  const loadAuthData = () => {
    const userData = localStorage.getItem("userData");
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

    setAuthData({
      userData: userData ? JSON.parse(userData) : null,
      token,
      role,
      isLoggedIn,
    });
  };

  useEffect(() => {
    loadAuthData();
  }, []);

  const storeDataToStorage = (user , token ) => {
    localStorage.setItem("userData", JSON.stringify(user));
    localStorage.setItem("token", token);
    localStorage.setItem("role", user.role);
    localStorage.setItem("isLoggedIn", "true");
    loadAuthData();
  };

  const logout = () => {
    localStorage.removeItem("userData");
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("isLoggedIn");
    setAuthData({
      userData: null,
      token: null,
      role: null,
      isLoggedIn: false,
    });
  };

  return (
    <AuthContext.Provider value={{ ...authData, storeDataToStorage, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
